<template>
  <div>
    <v-row>
      <page-title value="Class Diary"></page-title>
      <v-spacer></v-spacer>
      <!-- 印刷 -->
      <v-btn color="black" class="mx-2" variant="outlined">
        <v-icon start>mdi-printer</v-icon>
        Print
      </v-btn>
      <!-- 下書き保存 -->
      <v-btn color="primary" class="mx-2" variant="outlined">Save Draft</v-btn>
      <!-- 申請 -->
      <v-btn color="primary" class="ml-2" variant="flat">Submit</v-btn>
    </v-row>
    <v-row>
      <date-pager class="pt-4"></date-pager>
    </v-row>

    <v-container fluid class="pt-10">
      <v-row>
        <v-col cols="6">
          <div class="pb-2">Objective</div>
          <v-textarea variant="outlined"></v-textarea>
        </v-col>
        <v-col cols="6">
          <div class="pb-2">Activities</div>
          <v-text-field variant="outlined" label="Morning"></v-text-field>
          <v-text-field variant="outlined" label="Afternoon"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <div class="pb-2">Evaluation & Reflection</div>
          <v-textarea variant="outlined"></v-textarea>
        </v-col>
        <v-col cols="6">
          <div class="pb-2">Parent Support</div>
          <v-textarea variant="outlined"></v-textarea>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/atoms/PageTitle.vue";
import DatePager from "@/components/atoms/DatePager.vue";

export default defineComponent({
  name: "ClassReportDetail",

  components: {
    PageTitle,
    DatePager,
  },
});
</script>
